import { IRootState } from '../../../store'
import { IConfigurationOptionsState } from '../store/options.types'

export const getConfigurationOptionsSelector = (state: IRootState): IConfigurationOptionsState =>
  state.options.configurationOptions
